
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { LoginCredentials } from '../public/account/models/auth-credentials.model';
import { AppUrl } from '../public/common/constants/app-urls';
import { StringData } from '../public/common/models/string-data.model';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

@Injectable({
  providedIn: 'root',
})
export class SpringAuthService {
    //loggedIn = false;
  constructor(private router: Router, private http: HttpClient) {}

  
  isLooggedIn1() {
    //return this.loggedIn;
    //return this.localStorageService.getToken() !== null;
  }
/*
  logout() {
    //alert("heyy");
    this.localStorageService.loggedIn = false;
    this.localStorageService.removeToken();
    //this.router.navigate(['login']);
  }
*/

  login({ username, password }: any): Observable<StringData>{ 
    //const body = `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&grant_type=password`;

    let credentials: LoginCredentials = new LoginCredentials (username, password);
      
    return this.http.post<any>(AppUrl.login, { username, password }, httpOptions );
    
    
    //.subscribe((response: StringData) => {
        //console.log(response.data);
  
        //this.users.push({ name: response.name, job: response.job });
        //return of({data}:'data'});
       // if(response.data.startsWith("ey")){
            //console.log("hellooo");
            
            //this.loggedIn == true;
            //this.localStorageService.setToken(response.data);
            //return "OK";
        //}
        //return response.data;
      //});
//return "no result from network";
    //console.log(response.);

    //return of({ data: 'OKK'});
  }

  signup({ username, password, dealerType }: any): Observable<StringData>{ 
    //const body = `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&grant_type=password`;

    let credentials: LoginCredentials = new LoginCredentials (username, password);
      
    return this.http.post<any>(AppUrl.signup, { username, password, dealerType }, httpOptions );
    
  }

  recoverPassword(username: string): Observable<StringData>{ 
    //const body = `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&grant_type=password`;
 
    return this.http.post<any>(AppUrl.recoverPassword, username, httpOptions );
    
  }

  updatePassword(oldPassword: string, newPassword: string): Observable<StringData>{ 
  
    return this.http.post<any>(AppUrl.updatePassword, { oldPassword, newPassword }, httpOptions );
    
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
